import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { WorkflowService } from '../../../../../../../../shared/services/workflow.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../../state/app.state';
import { CommonService } from '../../../../../../../../shared/services/common.service';
import { ProjectsService } from '../../../../../../core/projects.service';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, takeUntil } from 'rxjs/operators';
import {
  ClearSubmittalsItemDetailsWithId,
  CreateSubmittalsItemRequest,
  DeleteSubmittalsItemRequest,
  ExecuteWorkflowActionStateRequest,
  FetchLineageRequest,
  FetchSubmittalsItemDetailsWithIdRequest,
  FetchSubmittalsRegistryListRequest,
  FetchUsersListRequest,
} from '../../../../../../core/projects.actions';
import {
  lineageList,
  submittalsItemDetails,
  submittalsItemsListInfo,
  submittalsRegistryListInfo,
  usersListInfo,
} from '../../../../../../core/projects.selectors';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { AuthService } from '../../../../../../../../shared/services';
import * as moment from 'moment';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../../../../../../shared/components';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { AnalyticsService } from '../../../../../../../../shared/services/analytics.service';
import {
  AddSubmittalsRegistryDialogComponent,
  AddSubmittalsRegistryDialogData,
} from '../add-submittals-registry-dialog/add-submittals-registry-dialog.component';

@Component({
    selector: 'app-create-or-edit-submittals-item',
    templateUrl: './create-or-edit-submittals-item.component.html',
    styleUrls: ['./create-or-edit-submittals-item.component.scss'],
    standalone: false
})
export class CreateOrEditSubmittalsItemComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('snTabGroup') tabs: MatTabGroup;
  data: any;
  errorMessages: any = {};
  errorMessageMap = {
    description: {
      required: 'This field is required.',
    },
    due_date: {
      required: 'This field is required.',
    },
    registry: {
      required: 'This field is required.',
    },
    submittal_no: {
      required: 'This field is required.',
    },
    title: {
      required: 'This field is required.',
    },
    attachmentType: {
      required: 'This field is required.',
    },
    actions__fyi_users: {
      required: 'This field is required.',
    },
    actions: {
      required: 'This field is required.',
    },
    actions__reviewers: {
      required: 'This field is required.',
    },
    actions_response_dropdown: {
      required: 'This field is required.',
    },
  };
  form = new FormGroup<any>({
    due_date: new FormControl({ value: null, disabled: false }),
    description: new FormControl({ value: null, disabled: false }),
    registry: new FormControl({ value: null, disabled: false }, { validators: [Validators.required] }),
    title: new FormControl({ value: null, disabled: false }, { validators: [Validators.required] }),
    submittal_no: new FormControl({ value: null, disabled: true }),
    spec_reference_no: new FormControl({ value: null, disabled: true }),
    attachmentType: new FormControl({ value: null, disabled: false }),
    pictures: new FormControl({ value: '[]', disabled: false }),
  });
  projectId: any;
  isFormDirty: boolean;
  ifFormDisabled = false;
  submittalsRegistryOptions = [];
  userOptions = [];
  actionsOptions = [];
  submittalsItemsList = [];
  attachmentTypeOptions: any = [
    { label: 'Product Info', value: 'product_info', value1: 'productinfo' },
    { label: 'Manual', value: 'manual', value1: 'manual' },
    { label: 'Plans', value: 'plans', value1: 'plans' },
    { label: 'Shop drawings', value: 'shop_drawings', value1: 'shopdrawings' },
  ];
  originalAttachmentTypeOptions: any = [
    { label: 'Product Info', value: 'product_info', value1: 'productinfo' },
    { label: 'Manual', value: 'manual', value1: 'manual' },
    { label: 'Plans', value: 'plans', value1: 'plans' },
    { label: 'Shop drawings', value: 'shop_drawings', value1: 'shopdrawings' },
  ];
  mediaFiles: any = [];
  selectedTabIndex = 0;
  tabIndexMap = {
    details: 0,
    discussion: 1,
  };
  attachmentTypes = [];
  tagMapping = {
    productinfo: 'product_info',
    manual: 'manual',
    plans: 'plans',
    shopdrawings: 'shop_drawings',
  };
  reMappingTag = {
    product_info: 'Product info',
    manual: 'Manual',
    plans: 'Plans',
    shop_drawings: 'Shop drawings',
  };
  valueMap = {
    product_info: 'productinfo',
    manual: 'manual',
    plans: 'plans',
    shop_drawings: 'shopdrawings',
  };
  statusMap = {
    submitted: {
      label: 'Awaiting approval',
      bgColor: 'bg-submitted',
      textColor: 'text-submitted',
    },
    approved: {
      label: 'Approved',
      bgColor: 'bg-approved',
      textColor: 'txt-approved',
    },
    rejected: {
      label: 'Rejected',
      bgColor: 'bg-rejected',
      textColor: 'txt-rejected',
    },
    draft: {
      label: 'Draft',
      bgColor: 'bg-draft',
      textColor: 'txt-draft',
    },
    sent_for_review: {
      label: 'Sent for review',
      bgColor: 'bg-submitted',
      textColor: 'text-submitted',
    },
    revise_and_resubmit: {
      label: 'Revise and resubmit',
      bgColor: 'bg-submitted',
      textColor: 'text-submitted',
    },
    approved_as_noted: {
      label: 'Approved as noted',
      bgColor: 'bg-submitted',
      textColor: 'text-submitted',
    },
    no_objection: {
      label: 'Reviewed for information only',
      bgColor: 'bg-submitted',
      textColor: 'text-submitted',
    },
  };
  role: any;
  account: any;
  selectedAction: any = [];
  actionsMediaFiles: any = [];
  registryValue: any;
  contractorRole: any;
  // Reviewers can't create registry entries (API acl); everyone else can add one inline.
  canAddRegistry = false;
  // Last title copied from a registry, so switching registries can replace it.
  copiedRegistryTitle: string | null = null;
  hideLink = true;
  displayNextActions = false;
  canDelete = false;
  // Responses a reviewer (designer) recorded; the contractor can't see these, so the PM
  // can copy one into their own decision.
  responseList: any = [];
  // States a reviewer records a response in.
  reviewerResponseStates = [
    'submittal-review',
    'submittal-approve',
    'submittal-reject',
    'submittal-approve-as-noted',
    'submittal-no-objection',
  ];
  // Decisions the contractor sees, so a copied response reaches them.
  copyResponseActions = [
    'submittal-approve',
    'submittal-reject',
    'submittal-approve-as-noted',
    'submittal-no-objection',
    'submittal-revise-and-resubmit',
  ];
  private copiedAttachmentIds: string[] = [];
  private previousSubmittalsItemId: string | null = null;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
    private workflowService: WorkflowService,
    private commonService: CommonService,
    private projectsService: ProjectsService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private analyticsService: AnalyticsService,
  ) {
    this.route.queryParams.pipe(takeUntil(this.onDestroy)).subscribe(qp => {
      const currentSubmittalsItemId = qp?.submittalsItemId;

      if (currentSubmittalsItemId) {
        if (currentSubmittalsItemId !== this.previousSubmittalsItemId) {
          this.previousSubmittalsItemId = currentSubmittalsItemId;
          this.store.dispatch(
            FetchSubmittalsItemDetailsWithIdRequest({ payload: { submittalsItemId: currentSubmittalsItemId } }),
          );
        }
      } else {
        if (this.previousSubmittalsItemId !== null) {
          this.previousSubmittalsItemId = null;
          this.store.dispatch(ClearSubmittalsItemDetailsWithId());
        }
      }
    });
  }

  ngOnInit() {
    const url = this.router.url;
    const path = url.split('?')[0];
    const segments = path.split('/');
    this.projectId = segments[segments.length - 1];

    this.account = this.authService.getCurrentUser();

    this.role = this.account.roles.find(obj => obj.project_id === this.projectId)?.role;

    this.contractorRole = !!this.role?.includes('contractor');
    this.canAddRegistry = !!this.role && this.role !== 'reviewer';

    if (this.role !== 'contractor') {
      this.form.addControl('actions', new FormControl({ value: null, disabled: false }), { emitEvent: false });

      this.form?.controls?.['actions'].valueChanges
        .pipe(debounceTime(200), takeUntil(this.onDestroy))
        .subscribe(value => {
          this.clearCopiedAttachments();

          Object.keys(this.form.controls)
            .filter(key => key.startsWith('actions_'))
            .forEach(key => this.form.removeControl(key, { emitEvent: false }));

          this.selectedAction = this.actionsOptions?.filter(o => o.state === value);

          if (this.copyResponseActions.includes(value)) {
            this.form.addControl(`actions_select_from_previous_responses`, new FormControl({
              value: false,
              disabled: false,
            }), { emitEvent: false });
          }

          this.selectedAction?.forEach(obj => {
            obj?.options?.formInputs?.forEach(o => {
              if (o?.name === 'attachments') {
                this.form.addControl(`actions_pictures`, new FormControl({ value: '[]', disabled: false }), {
                  emitEvent: false,
                });
              }
              this.form.addControl(`actions_${o?.name}`, new FormControl({ value: null, disabled: false }), {
                emitEvent: false,
              });
            });
          });
        });
    } else {
      this.form.removeControl('actions', { emitEvent: false });

      Object.keys(this.form.controls)
        .filter(key => key.startsWith('actions_'))
        .forEach(key => this.form.removeControl(key, { emitEvent: false }));
    }

    this.form?.controls?.['registry'].valueChanges.pipe(takeUntil(this.onDestroy)).subscribe(v => {
      this.registryValue = v;
      this.copyRegistryTitle(v);
      setTimeout(() => {
        this.generateSubmittalNo();
      });
    });

    this.store
      .select(submittalsItemsListInfo)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data && data.list?.length > 0) {
          this.submittalsItemsList = [...data.list];

          setTimeout(() => {
            this.generateSubmittalNo();
          });
        } else {
          this.submittalsItemsList = [];
        }
      });

    this.projectsService.removeActionFieldsFromForm.pipe(takeUntil(this.onDestroy)).subscribe(data => {
      if (data) {
        Object.keys(this.form.controls)
          .filter(key => key.startsWith('actions_'))
          .forEach(key => this.form.removeControl(key, { emitEvent: false }));
      }
    });

    this.projectsService.isAnyFormDirty.pipe(takeUntil(this.onDestroy)).subscribe(dirty => {
      this.isFormDirty = dirty;
    });

    this.route.queryParams.pipe(takeUntil(this.onDestroy)).subscribe(qp => {
      if (qp.snSubTab) {
        this.selectedTabIndex = this.tabIndexMap[qp.snSubTab] || 0;
      }
    });

    this.commonService.uploadedFilesInfo.pipe(takeUntil(this.onDestroy)).subscribe(data => {
      const items = Array.isArray(data) ? data : [data];

      items.forEach((eachItem: any) => {
        if (eachItem?.['fileType'] === 'picture' || eachItem?.['fileType'] === 'document') {
          if (!eachItem?.tags?.length) {
            let pictures: any = this.form.get('actions_pictures')?.value || '[]';
            pictures = JSON.parse(pictures);

            pictures.push(eachItem);
            this.form?.get('actions_pictures')?.setValue(JSON.stringify(pictures), { emitEvent: true });
            this.mediaFiles?.push(eachItem);
          } else {
            let pictures: any = this.form.get('pictures')?.value || '[]';
            pictures = JSON.parse(pictures);

            pictures.push(eachItem);
            this.form?.get('pictures')?.setValue(JSON.stringify(pictures), { emitEvent: true });
            this.mediaFiles?.push(eachItem);
          }
        }
      });

      this.projectsService.mediaData.next(this.mediaFiles);
    });

    this.projectsService.changeView.pipe(takeUntil(this.onDestroy)).subscribe(data => {
      if (Object.keys(data)?.length) {
        this.data = {};
        this.mediaFiles = [];
        this.attachmentTypes = [];

        Object.keys(this.form.controls)
          .filter(key => key.startsWith('attachmentType'))
          .forEach(key => this.form.removeControl(key, { emitEvent: false }));

        this.data = this.workflowService.gateNextActions(data);
        this.fetchReviewerResponses();

        if (this.data?.id) {
          this.form.patchValue(
            {
              title: this.data?.title,
              registry: this.data?.submittal_log?.id,
              submittal_no: this.data?.submittal_no,
              spec_reference_no: this.data?.spec_reference_no,
              due_date: this.data?.due_date,
              description: this.data?.description,
              cc_users: this.data?.cc_users?.map(u => u.value),
              reviewers: this.data?.reviewers?.map(u => u.value),
            },
            { emitEvent: false },
          );

          if (this.data?.attachments?.length) {
            const mediaFiles = this.data?.attachments;
            this.mediaFiles = [...mediaFiles];
            mediaFiles.forEach(attachment => {
              if (Array.isArray(attachment?.tags)) {
                attachment?.tags?.forEach(tag => {
                  const mappedTag = this.tagMapping[tag];
                  if (mappedTag && !this.attachmentTypes.includes(mappedTag)) {
                    this.attachmentTypes.push(mappedTag);
                  }
                });
              }
            });

            this.attachmentTypes.forEach((type, index) => {
              const controlName = index === 0 ? 'attachmentType' : `attachmentType${index}`;

              if (!this.form.contains(controlName)) {
                this.form.addControl(controlName, new FormControl({ value: null, disabled: false }), {
                  emitEvent: false,
                });
              }

              this.form.get(controlName)?.setValue(type, { emitEvent: false });
            });

            this.form.get('pictures')?.setValue(JSON.stringify(mediaFiles), { emitEvent: false });
          } else {
            if (!this.form.contains('attachmentType')) {
              this.form.addControl('attachmentType', new FormControl({ value: null, disabled: false }), {
                emitEvent: false,
              });
            }

            this.attachmentTypeOptions = this.originalAttachmentTypeOptions;
          }

          setTimeout(() => {
            this.projectsService.mediaData.next(this.mediaFiles);
          });

          if (this.data?.['next-actions']?.[0]?.actions?.length) {
            this.actionsOptions = this.data?.['next-actions']?.[0]?.actions?.map(o => {
              return {
                ...o,
                label: o?.options?.label,
                value: o?.state,
              };
            });
            this.displayNextActions = true;
          } else {
            this.displayNextActions = false;
          }
        }

        this.projectsService.isAnyFormDirty.next(false);

        const selectedValues = Object.keys(this.form.controls)
          .filter(k => k.startsWith('attachmentType'))
          .map(k => this.form.controls[k].value)
          .filter(v => v !== null && v !== undefined);

        this.attachmentTypeOptions = this.attachmentTypeOptions.filter(o => !selectedValues.includes(o.value));

        this.updateHideLinkState();
        this.updateFormState();
      }
    });

    this.form.valueChanges.pipe(takeUntil(this.onDestroy)).subscribe(() => {
      this.updateHideLinkState();
      this.projectsService.isAnyFormDirty.next(true);
    });

    this.store
      .select(submittalsRegistryListInfo)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data && data.list?.length > 0) {
          this.submittalsRegistryOptions = [...data.list];
        }
      });

    this.store
      .select(usersListInfo)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data && data.list?.length > 0) {
          // The Reviewers / FYI pickers leave out accounts only on the contractor side of this
          // project: a contractor never sees review steps and can't respond (mobile does the same).
          this.userOptions = data.list.filter(user => {
            const here = (user?.roles || []).filter(r => r?.project_id === this.projectId);
            return !here.length || here.some(r => !String(r?.role || '').startsWith('contractor'));
          });
        }
      });

    this.fetchSubmittalsRegistry();
    this.fetchUsersList();

    this.store
      .select(submittalsItemDetails)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (Object.keys(data)?.length) {
          this.data = {};
          this.mediaFiles = [];
          this.attachmentTypes = [];

          Object.keys(this.form.controls)
            .filter(key => key.startsWith('attachmentType'))
            .forEach(key => this.form.removeControl(key, { emitEvent: false }));

          this.data = this.workflowService.gateNextActions(data);
          this.fetchReviewerResponses();

          if (this.data?.id) {
            this.form.patchValue(
              {
                title: this.data?.title,
                registry: this.data?.submittal_log?.id,
                submittal_no: this.data?.submittal_no,
                spec_reference_no: this.data?.spec_reference_no,
                due_date: this.data?.due_date,
                description: this.data?.description,
                cc_users: this.data?.cc_users?.map(u => u.value),
                reviewers: this.data?.reviewers?.map(u => u.value),
              },
              { emitEvent: false },
            );

            if (this.data?.attachments?.length) {
              const mediaFiles = this.data?.attachments;
              this.mediaFiles = [...mediaFiles];
              mediaFiles.forEach(attachment => {
                if (Array.isArray(attachment?.tags)) {
                  attachment?.tags?.forEach(tag => {
                    const mappedTag = this.tagMapping[tag];
                    if (mappedTag && !this.attachmentTypes.includes(mappedTag)) {
                      this.attachmentTypes.push(mappedTag);
                    }
                  });
                }
              });

              this.attachmentTypes.forEach((type, index) => {
                const controlName = index === 0 ? 'attachmentType' : `attachmentType${index}`;

                if (!this.form.contains(controlName)) {
                  this.form.addControl(controlName, new FormControl({ value: null, disabled: false }), {
                    emitEvent: false,
                  });
                }

                this.form.get(controlName)?.setValue(type, { emitEvent: false });
              });

              this.form.get('pictures')?.setValue(JSON.stringify(mediaFiles), { emitEvent: false });
            } else {
              if (!this.form.contains('attachmentType')) {
                this.form.addControl('attachmentType', new FormControl({ value: null, disabled: false }), {
                  emitEvent: false,
                });
              }

              this.attachmentTypeOptions = this.originalAttachmentTypeOptions;
            }

            setTimeout(() => {
              this.projectsService.mediaData.next(this.mediaFiles);
            });

            if (this.data?.['next-actions']?.[0]?.actions?.length) {
              this.actionsOptions = this.data?.['next-actions']?.[0]?.actions?.map(o => {
                return {
                  ...o,
                  label: o?.options?.label,
                  value: o?.state,
                };
              });
              this.displayNextActions = true;
            } else {
              this.displayNextActions = false;
            }
          }

          this.projectsService.isAnyFormDirty.next(false);

          const selectedValues = Object.keys(this.form.controls)
            .filter(k => k.startsWith('attachmentType'))
            .map(k => this.form.controls[k].value)
            .filter(v => v !== null && v !== undefined);

          this.attachmentTypeOptions = this.attachmentTypeOptions.filter(o => !selectedValues.includes(o.value));

          this.updateHideLinkState();
          this.updateFormState();
        }
      });

    this.store
      .select(lineageList)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        // The lineage slice is shared with the RFI and Discussion views, so only use
        // entries recorded on this submittal.
        const steps = (Array.isArray(data) ? data : []).filter(o => this.data?.id && o?.input?.id === this.data.id);
        // Only people this submittal was sent to for review count as reviewers, so a
        // PM's own Send for review isn't offered.
        const reviewerIds = new Set(steps.flatMap(o => o?.input?.formValues?._reviewers || []));
        this.responseList = steps
          .filter(o =>
            reviewerIds.has(o?.actor?.id)
            && this.reviewerResponseStates.includes(o?.state?.name)
            && o?.actor?.id !== this.account?.id
            && (o?.input?.formValues?.comments || o?.attachments?.length),
          )
          .map(o => {
            const actorName = `${o.actor?.first_name || ''} ${o.actor?.last_name || ''}`.trim();
            const verdict = o.state?.params?.label || o.state?.name;
            return {
              ...o,
              actorName,
              verdict,
              label: `${actorName} · ${verdict} · ${moment(o.created_at).format('MMM D')}`,
              value: o.id,
              response: o?.input?.formValues?.comments,
            };
          });
      });

    this.form?.controls?.['attachmentType'].valueChanges.pipe(takeUntil(this.onDestroy)).subscribe(v => {
      if (v) {
        this.form.controls['attachmentType'].setValue(v, { emitEvent: false });
        this.cdRef.detectChanges();
        this.updateHideLinkState();
      }
    });
  }

  ngAfterViewInit() {
    this.projectsService.isAnyFormDirty.next(false);
    // The tab group only renders for an existing item.
    if (this.tabs) {
      this.tabs._handleClick = this.onTabChange?.bind(this);
    }
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField),
    };
  }

  save() {
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }

    const values = this.form.getRawValue();
    const attachments = JSON.parse(values?.pictures).map(o => o.id);

    const payload = {
      title: values?.title,
      submittal_log_id: values?.registry,
      description: values?.description,
      due_date: moment.isMoment(values.due_date) ? values.due_date.format('YYYY-MM-DD') : values.due_date,
      projectId: this.projectId,
      attachments,
      qp: {},
    };

    const tempPayload = {
      payload,
      type: 'save',
    };

    if (this.data?.id) {
      tempPayload['payload']['id'] = this.data?.id;
    }

    this.store.dispatch(CreateSubmittalsItemRequest({ payload: tempPayload }));

    if (this.data?.id) {
      this.analyticsService.capture('submittal_updated', {
        project_id: this.projectId,
        action: 'save',
      });
    } else {
      this.analyticsService.capture('submittal_created', {
        project_id: this.projectId,
        action: 'save',
      });
    }
  }

  submit() {
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }

    const values = this.form.getRawValue();
    const attachments = JSON.parse(values?.pictures).map(o => o.id);

    const payload = {
      title: values?.title,
      submittal_log_id: values?.registry,
      description: values?.description,
      due_date: moment.isMoment(values.due_date) ? values.due_date.format('YYYY-MM-DD') : values.due_date,
      projectId: this.projectId,
      attachments,
      qp: {},
    };

    const tempPayload = {
      payload,
      type: 'submit',
    };

    if (this.data?.id) {
      tempPayload['payload']['id'] = this.data?.id;
    }

    this.store.dispatch(CreateSubmittalsItemRequest({ payload: tempPayload }));

    if (this.data?.id) {
      this.analyticsService.capture('submittal_updated', {
        project_id: this.projectId,
        action: 'submit',
      });
    } else {
      this.analyticsService.capture('submittal_created', {
        project_id: this.projectId,
        action: 'submit',
      });
    }
  }

  // Prefill the submittal title from the registry, but never overwrite a title the user typed.
  copyRegistryTitle(registryId: string): void {
    const registryTitle = this.submittalsRegistryOptions.find(o => o.id === registryId)?.title;
    const titleControl = this.form.controls['title'];
    const currentTitle = titleControl?.value;

    if (!registryTitle || !titleControl || titleControl.disabled) {
      return;
    }

    if (!currentTitle || currentTitle === this.copiedRegistryTitle) {
      titleControl.setValue(registryTitle);
      this.copiedRegistryTitle = registryTitle;
      this.errorMessages = { ...this.errorMessages, title: '' };
    }
  }

  openAddRegistryDialog(searchText?: string): void {
    const data: AddSubmittalsRegistryDialogData = {
      projectId: this.projectId,
      existingRegistries: this.submittalsRegistryOptions,
      title: searchText || null,
    };

    this.dialog
      .open(AddSubmittalsRegistryDialogComponent, {
        data,
        width: '420px',
        maxHeight: '90vh',
        panelClass: 'floating-dialog-box',
        disableClose: true,
      })
      .afterClosed()
      .pipe(takeUntil(this.onDestroy))
      .subscribe(created => {
        if (!created?.id) {
          return;
        }

        // Add it locally so it can be selected (and the submittal no generated) before the refetch lands.
        this.submittalsRegistryOptions = [
          {
            ...created,
            heading: [created.section_no, created.sub_section_no].filter(Boolean).join('/'),
            value: created.id,
            label: created.title,
          },
          ...this.submittalsRegistryOptions,
        ];
        this.form.controls['registry'].setValue(created.id);
        this.form.controls['registry'].markAsDirty();
        this.errorMessages = { ...this.errorMessages, registry: '' };
        this.commonService.notification(`Registry entry ${this.submittalsRegistryOptions[0].heading} added`, 'success');
        this.fetchSubmittalsRegistry();
      });
  }

  fetchSubmittalsRegistry(): void {
    const payload = {
      start: 0,
      total: 1000,
      include: ['createdBy'],
      projectId: this.projectId,
    };

    if (this.projectId) {
      this.store.dispatch(FetchSubmittalsRegistryListRequest({ payload }));
    }
  }

  fetchUsersList(): void {
    const payload = {
      start: 0,
      total: 1000,
      include: ['roles'],
      // users.list builds its query string from qp only: the pickers need each user's roles.
      qp: { include: 'roles' },
      projectId: this.projectId,
    };

    if (this.projectId) {
      this.store.dispatch(FetchUsersListRequest({ payload }));
    }
  }

  deletePicture(pic) {
    if (pic.fileType === 'picture' || pic.fileType === 'document') {
      const pictures = this.getPictures()?.filter(o => o.id !== pic.id) || [];
      this.mediaFiles = this.mediaFiles?.filter(o => o.id !== pic.id) || [];
      this.form?.get('pictures')?.setValue(JSON.stringify(pictures));
    }

    const tagsArray = [...new Set(this.mediaFiles.map(mf => mf.tags?.[0]).filter(Boolean))];

    const activeTagValues = new Set(tagsArray);

    for (const key of Object.keys(this.form.controls)) {
      if (key.startsWith('attachmentType')) {
        const controlValue = this.form.controls[key].value;
        const mappedValue = this.valueMap?.[controlValue];
        if (controlValue && !activeTagValues.has(mappedValue)) {
          this.form.removeControl(key);
        }
      }
    }

    const selectedValues = Object.keys(this.form.controls)
      .filter(k => k.startsWith('attachmentType'))
      .map(k => this.form.controls[k].value)
      .filter(Boolean);

    this.attachmentTypeOptions = this.originalAttachmentTypeOptions.filter(o => !selectedValues.includes(o.value));

    const hasAnyAttachmentType = Object.keys(this.form.controls).some(k => k.startsWith('attachmentType'));

    if (!hasAnyAttachmentType && this.originalAttachmentTypeOptions.length) {
      this.form.addControl('attachmentType', new FormControl({ value: null, disabled: false }));
    }

    this.updateHideLinkState();

    setTimeout(() => this.projectsService.mediaData.next(this.mediaFiles));
  }

  deleteActionPicture(pic) {
    const pictures = this.getActionPictures()?.filter(o => o.id !== pic.id) || [];
    this.mediaFiles = this.mediaFiles?.filter(o => o.id !== pic.id) || [];
    this.form.controls['actions_pictures']?.setValue(JSON.stringify(pictures));
    this.projectsService.mediaData.next(this.mediaFiles);
  }

  getPictures() {
    const pictures = this.form.controls['pictures']?.value || '[]';
    return JSON.parse(pictures);
  }

  getActionPictures() {
    const pictures = this.form.controls['actions_pictures']?.value || '[]';
    return JSON.parse(pictures);
  }

  addAnotherType() {
    const baseName = 'attachmentType';
    let newName = baseName;
    let counter = 1;

    while (this.form.contains(newName)) {
      newName = `${baseName}${counter}`;
      counter++;
    }

    const selectedValues = Object.keys(this.form.controls)
      .filter(k => k.startsWith(baseName))
      .map(k => this.form.controls[k].value)
      .filter(v => v !== null && v !== undefined);

    const availableOptions = this.attachmentTypeOptions.filter(o => !selectedValues.includes(o.value));

    if (availableOptions.length > 0) {
      this.form.addControl(newName, new FormControl(null));
      this.attachmentTypeOptions = availableOptions;
    }

    this.updateHideLinkState();
  }

  getAttachmentTypeKeys() {
    return Object.keys(this.form.controls).filter(k => k.startsWith('attachmentType'));
  }

  isAttachmentSelected(controlName: string): boolean {
    return !!this.form.get(controlName)?.value;
  }

  onTabChange(event: MatTabChangeEvent) {
    const label = event?.['textLabel']?.toLowerCase()?.replace(/\s+/g, '-');

    if (!label) {
      return;
    }

    if (this.isFormDirty) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        data: new ConfirmDialogModel(
          'Unsaved changes',
          `There are unsaved changes.<br/>Are you sure you want to discard?`,
        ),
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.router
            .navigate([], {
              queryParams: { snSubTab: label },
              queryParamsHandling: 'merge',
            })
            .then(() => {
              this.projectsService.isAnyFormDirty.next(false);
            });
        }
      });
    } else {
      this.router.navigate([], {
        queryParams: { snSubTab: label },
        queryParamsHandling: 'merge',
      });
    }
  }

  get nextActionsList() {
    return this.data?.['next-actions']?.[0]?.actions ?? [];
  }

  get primaryActions() {
    return this.nextActionsList.filter(action => action?.options?.styles?.color === 'primary');
  }

  get menuActions() {
    return this.nextActionsList.filter(
      action => action?.options?.styles?.color === 'accent' || action?.options?.styles?.color === 'warn',
    );
  }

  executeState(action) {
    if (action.state === 'submittal-submit') {
      if (this.isFormDirty) {
        if (this.form.invalid) {
          this.checkForErrors();
          return;
        }

        const values = this.form.getRawValue();
        const attachments = JSON.parse(values?.pictures).map(o => o.id);

        const payload = {
          title: values?.title,
          submittal_log_id: values?.registry,
          description: values?.description,
          due_date: moment.isMoment(values.due_date) ? values.due_date.format('YYYY-MM-DD') : values.due_date,
          projectId: this.projectId,
          attachments,
          qp: {},
        };

        const tempPayload = {
          payload,
          type: 'submit',
        };

        if (this.data?.id) {
          tempPayload['payload']['id'] = this.data?.id;
        }

        this.store.dispatch(CreateSubmittalsItemRequest({ payload: tempPayload }));
      } else {
        if (!action?.options?.formInputs?.length) {
          const { wf, ex, state } = action;

          const qp = { wf, ex, state };

          const payload = {
            projectId: this.projectId,
            qp,
            input: {
              id: this.data?.id,
            },
          };

          const tempPayload = {
            type: 'submittals',
            payload,
          };

          this.store.dispatch(ExecuteWorkflowActionStateRequest({ payload: tempPayload }));
        }
      }
    } else {
      if (!action?.options?.formInputs?.length) {
        const { wf, ex, state } = action;

        const qp = { wf, ex, state };

        const payload = {
          projectId: this.projectId,
          qp,
          input: {
            id: this.data?.id,
          },
        };

        const tempPayload = {
          type: 'submittals',
          payload,
        };

        this.store.dispatch(ExecuteWorkflowActionStateRequest({ payload: tempPayload }));
      }
    }
  }

  execute() {
    const { wf, ex, state } = this.selectedAction[0];

    const qp = { wf, ex, state };

    const fvs = this.form.getRawValue();
    const tempPics = JSON.parse(fvs.actions_pictures || '[]')?.map(o => o?.id);

    const payload = {
      projectId: this.projectId,
      qp,
      input: {
        formValues: {
          _reviewers: fvs?.actions__reviewers,
          _fyi_users: fvs?.actions__fyi_users,
          comments: fvs?.actions_comments,
          attachments: tempPics,
        },
        id: this.data?.id,
      },
    };

    const tempPayload = {
      type: 'submittals',
      payload,
    };

    this.store.dispatch(ExecuteWorkflowActionStateRequest({ payload: tempPayload }));
  }

  fetchReviewerResponses() {
    this.responseList = [];
    if (!this.data?.id) {
      return;
    }

    this.store.dispatch(FetchLineageRequest({
      payload: {
        qp: {
          start: 0,
          total: 1000,
          ex: `submittal-approval/${this.data.id}`,
          include: ['actor', 'state', 'attachments'],
        },
      },
    }));
  }

  onToggle(event: MatSlideToggleChange) {
    this.form.controls['actions_select_from_previous_responses']?.setValue(event.checked, { emitEvent: false });

    if (event.checked) {
      this.form.addControl(`actions_response_dropdown`, new FormControl({ value: null, disabled: false }), {
        emitEvent: false,
      });

      this.form.controls['actions_response_dropdown'].valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(ids => {
          const selected = this.responseList
            .filter(r => [].concat(ids || []).includes(r?.id))
            .sort((a, b) => moment(a.created_at).valueOf() - moment(b.created_at).valueOf());
          this.copyReviewerResponses(selected);
        });
    } else {
      this.form.removeControl(`actions_response_dropdown`, { emitEvent: false });
    }
  }

  /**
   * Fill the PM's comments and attachments from the picked reviewer responses,
   * replacing whatever an earlier pick copied in. With more than one pick, each
   * response's comments go under its reviewer's name and verdict.
   */
  copyReviewerResponses(responses) {
    this.clearCopiedAttachments();

    const comments = responses.length > 1
      ? responses
        .filter(r => r.response)
        .map(r => `${r.actorName} (${r.verdict}):\n${r.response}`)
        .join('\n\n')
      : responses[0]?.response || '';

    // Untagged, so they show in the action's Attachments section and are sent with it.
    const copied = [];
    responses.flatMap(r => r.attachments || []).forEach(a => {
      if (a?.id && !this.mediaFiles.some(m => m?.id === a.id) && !copied.some(c => c.id === a.id)) {
        copied.push({ ...a, tags: [] });
      }
    });
    this.copiedAttachmentIds = copied.map(a => a.id);

    this.mediaFiles = [...this.mediaFiles, ...copied];
    this.form.patchValue(
      {
        actions_comments: comments,
        actions_pictures: JSON.stringify([...this.getActionPictures(), ...copied]),
      },
      { emitEvent: false },
    );

    setTimeout(() => this.projectsService.mediaData.next(this.mediaFiles));
  }

  clearCopiedAttachments() {
    if (!this.copiedAttachmentIds.length) {
      return;
    }

    const ids = this.copiedAttachmentIds;
    this.copiedAttachmentIds = [];
    this.mediaFiles = this.mediaFiles.filter(m => !ids.includes(m?.id));
    if (this.form.controls['actions_pictures']) {
      this.form.controls['actions_pictures'].setValue(
        JSON.stringify(this.getActionPictures().filter(o => !ids.includes(o?.id))),
        { emitEvent: false },
      );
    }
    setTimeout(() => this.projectsService.mediaData.next(this.mediaFiles));
  }

  generateSubmittalNo() {
    if (!this.registryValue || !this.submittalsItemsList?.length) {
      return;
    }

    const selectedRegistry = this.submittalsRegistryOptions.find(o => o.id === this.registryValue);

    if (!selectedRegistry) {
      return;
    }

    const baseDraft = `${selectedRegistry.section_no ?? ''}-${selectedRegistry.sub_section_no ?? ''}#`;

    const matchingItems = this.submittalsItemsList.filter(o => o?.submittalsLogDraft === baseDraft);

    const newSpecRefNo = matchingItems.length
      ? `${matchingItems[0].submittalsLogDraft}-${(matchingItems[0].submittalsLogDraftFrequency ?? 0) + 1}-Rev0`
      : `${baseDraft}1-Rev0`;

    const specReference = this.data?.submittal_no ? this.data.spec_reference_no : newSpecRefNo;

    this.form.patchValue({ spec_reference_no: specReference }, { emitEvent: false });
  }

  updateHideLinkState() {
    const hasSelectedAttachmentType = Object.keys(this.form.controls)
      .filter(key => key.startsWith('attachmentType'))
      .some(key => !!this.form.controls[key].value);

    this.hideLink = !hasSelectedAttachmentType;
  }

  updateFormState() {
    if (this.contractorRole && this.data.status !== 'draft') {
      this.ifFormDisabled = true;
      this.form.disable({ emitEvent: false });
    } else {
      this.ifFormDisabled = false;
      this.form.enable({ emitEvent: false });
    }

    const createdByUuid = this.data?.createdBy?.id || this.data?.createdBy?.uuid;
    this.canDelete = this.data?.status === 'draft' && createdByUuid === this.account?.id;

    this.cdRef.detectChanges();
  }

  deleteSubmittal() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      data: new ConfirmDialogModel(
        'Delete Submittal',
        'Are you sure you want to delete this submittal?',
      ),
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.store.dispatch(
          DeleteSubmittalsItemRequest({
            payload: {
              id: this.data.id,
              projectId: this.projectId,
            },
          })
        );
      }
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
